import React, { PropsWithChildren, useMemo } from 'react';
import { isNumber } from 'lodash';
import { routesPath } from '../../../core/enums/pathEnum';
import { PermissionEnum } from '../../../core/enums/dictionariesEnums';
import PrivateLineLink from '../../../common/components/private-line-link/PrivateLineLink';

interface StockProductLinkProps {
  partId?: number | null;
  partsKitComponentPartId?: number | null;
  partsKitId?: number | null;
}

const getPartUrl = (partId?: number | null, partsKitComponentPartId?: number | null): string | null => {
  const id = partId ?? partsKitComponentPartId;
  if (!isNumber(id)) {
    return null;
  }

  return `/${routesPath.STOCK}/part/${id}`;
};

const getPartKitUrl = (partsKitId?: number | null): string | null => {
  if (!isNumber(partsKitId)) {
    return null;
  }

  return `/${routesPath.STOCK}/${routesPath.PARTS_KITS}/${partsKitId}`;
};

export const StockProductLink = ({
  partsKitComponentPartId, partsKitId, partId, children,
}: PropsWithChildren<StockProductLinkProps>) => {
  const partUrl = useMemo(() => getPartUrl(partId, partsKitComponentPartId), [partId, partsKitComponentPartId]);
  const partKitUrl = useMemo(() => getPartKitUrl(partsKitId), [partsKitId]);

  if (partUrl) {
    return <PrivateLineLink to={partUrl} permission={PermissionEnum.StockPartViewPage}>
      {children}
    </PrivateLineLink>;
  }

  if (partKitUrl) {
    return <PrivateLineLink to={partKitUrl} permission={PermissionEnum.StockPartsKitViewPage}>
      {children}
    </PrivateLineLink>;
  }

  return <>{children}</>;
};
